export default __webpack_public_path__ + "static/media/imatge-slider-portada-6.1dcefa03.jpg";